export default __webpack_public_path__ + "static/media/27.97b9183e.pdf";